if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.isZoomed = false;
        this.dragDistance = 0;
        this.activeImage = null;
      }

      hide() {
        // const currentSlide = document.querySelector('.slider-item.active img');
        // if (currentSlide) {
        //   currentSlide.style.transform = 'scale(1) translate(0px, 0px)';
        //   currentSlide.style.cursor = '';
        //   window.isZoomed = false;
        // }
        this.isZoomed = false;
        this.dragDistance = 0;
        this.activeImage = null;
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        // this.querySelectorAll(
        //   `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
        //     "data-media-id"
        //   )}"])`
        // ).forEach((element) => {
        //   element.classList.remove("active");
        // });
        // const activeMedia = this.querySelector(
        //   `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        // );
        // if (!activeMedia) return;
        // const activeMediaTemplate = activeMedia.querySelector("template");
        // const activeMediaContent = activeMediaTemplate
        //   ? activeMediaTemplate.content
        //   : null;
        // activeMedia.classList.add("active");
        // activeMedia.scrollIntoView();

        // const container = this.querySelector('[role="document"]');
        // container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        // if (
        //   activeMedia.nodeName == "DEFERRED-MEDIA" &&
        //   activeMediaContent &&
        //   activeMediaContent.querySelector(".js-youtube")
        // )
        //   activeMedia.loadContent();

        const sliderContainer = document.querySelector(
          ".product-media-modal__content .slider-container"
        );
        const sliderItems = sliderContainer.querySelectorAll(".slider-item");
        const prevButton = document.querySelector(
          '.product-media-modal__content [rel="prev"]'
        );
        const nextButton = document.querySelector(
          '.product-media-modal__content [rel="next"]'
        );
        const currentPageEl = document.querySelector(
          ".pagination__current-page"
        );
        const pageCountEl = document.querySelector(".pagination__page-count");

        let isDragging = false;
        let startX = 0;
        let startY = 0;
        let currentX = 0;
        let currentY = 0;
        let lastTouchTime = 0;
        const isMobile = /Mobi|Android/i.test(navigator.userAgent);

        const DRAG_IGNORE_THRESHOLD = 5;
        const DOUBLE_TAP_DELAY = 300;

        let currentIndex = window.currentIndex;

        currentPageEl.textContent = currentIndex;
        pageCountEl.textContent = sliderItems.length;

        const updateSlider = (index) => {
          sliderItems.forEach((item, i) => {
            item.classList.toggle("active", i === index - 1);
          });

          currentPageEl.textContent = index;

          const activeItem = sliderItems[index - 1];
          this.activeImage = activeItem.querySelector("img");

          if (this.activeImage) {
            this.activeImage.style.transform = "scale(1) translate(0px, 0px)";
            this.activeImage.style.cursor = "";
            this.isZoomed = false;
            this.dragDistance = 0;
            lastTouchTime = 0;
            currentX = currentY = 0;
          }
        };

        const handlePrevClick = () => {
          if (currentIndex === 1) return;
          this.dragDistance = 0;
          lastTouchTime = 0;
          currentX = currentY = 0;
          currentIndex = currentIndex - 1;
          updateSlider(currentIndex);
        };

        const handleNextClick = () => {
          if (currentIndex === sliderItems.length) return;
          this.dragDistance = 0;
          lastTouchTime = 0;
          currentX = currentY = 0;
          currentIndex = currentIndex + 1;
          updateSlider(currentIndex);
        };

        const zoomImage = () => {
          if (!this.activeImage) return;
          this.dragDistance = 0;
          lastTouchTime = 0;

          if (this.isZoomed) {
            this.activeImage.style.transform = 'scale(1) translate(0px, 0px)';
            this.activeImage.style.cursor = '';
            this.isZoomed = false;
          } else {
            // this.activeImage.style.transition = 'transform 0.1s ease-out';
            this.activeImage.style.transform = 'scale(2.5) translate(0px, 0px)';
            this.activeImage.style.cursor = 'grab';
            this.isZoomed = true;
          }

          currentX = currentY = 0;
        };

        const startDrag = (event) => {
          if (!this.activeImage || !this.isZoomed) return;

          isDragging = true;
          this.dragDistance = 0;

          const clientX = event.touches ? event.touches[0].clientX : event.clientX;
          const clientY = event.touches ? event.touches[0].clientY : event.clientY;

          startX = clientX - currentX;
          startY = clientY - currentY;

          this.activeImage.style.cursor = 'grabbing';
        };

        const dragImage = (event) => {
          if (!isDragging || !this.activeImage || !this.isZoomed) return;

          event.preventDefault();
          const clientX = event.touches ? event.touches[0].clientX : event.clientX;
          const clientY = event.touches ? event.touches[0].clientY : event.clientY;

          const deltaX = clientX - startX;
          const deltaY = clientY - startY;
          this.dragDistance = Math.sqrt(deltaX ** 2 + deltaY ** 2);

          currentX = deltaX;
          currentY = deltaY;

          const containerRect = sliderContainer.getBoundingClientRect();
          const imageRect = this.activeImage.getBoundingClientRect();

          const scale = 2.5;
          const maxTranslateX = (imageRect.width * scale - containerRect.width) / 15;
          const maxTranslateY = (imageRect.height * scale - containerRect.height) / 15;

          currentX = Math.max(-maxTranslateX, Math.min(currentX, maxTranslateX));
          currentY = Math.max(-maxTranslateY, Math.min(currentY, maxTranslateY));

          this.activeImage.style.transform = `scale(${scale}) translate(${currentX}px, ${currentY}px)`;
        };

        const stopDrag = () => {
          if (!this.activeImage || !this.isZoomed) return;

          isDragging = false;

          this.activeImage.style.cursor = 'grab';

          const containerRect = sliderContainer.getBoundingClientRect();
          const imageRect = this.activeImage.getBoundingClientRect();

          const scale = 2.5;

          if (imageRect.left > containerRect.left) {
            currentX -= (imageRect.left - containerRect.left) / scale;
          } else if (imageRect.right < containerRect.right) {
            currentX += (containerRect.right - imageRect.right) / scale;
          }

          if (imageRect.top > containerRect.top) {
            currentY -= (imageRect.top - containerRect.top) / scale;
          } else if (imageRect.bottom < containerRect.bottom) {
            currentY += (containerRect.bottom - imageRect.bottom) / scale;
          }

          this.activeImage.style.transition = 'transform 0.3s ease-out';
          this.activeImage.style.transform = `scale(${scale}) translate(${currentX}px, ${currentY}px)`;

          setTimeout(() => {
            this.activeImage.style.transition = '';
          }, 300);
        };


        sliderContainer.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          event.stopImmediatePropagation();
          if (!isMobile) {
            if (this.dragDistance > DRAG_IGNORE_THRESHOLD) {
              return;
            }
            if (event.target.tagName === 'IMG') {
              zoomImage();
            }
          }
        });

        // Mouse events
        sliderContainer.addEventListener("mousedown", (event) => {
          event.preventDefault();
          startDrag(event);
        });
        sliderContainer.addEventListener("mousemove", dragImage);
        sliderContainer.addEventListener("mouseup", stopDrag);
        sliderContainer.addEventListener("mouseleave", () => {
          if (isDragging) stopDrag();
        });

        // Touch events
        sliderContainer.addEventListener("touchstart", startDrag);
        sliderContainer.addEventListener("touchmove", dragImage);
        //If you wanna roll back to one-tap zoom, uncomment the next line and comment the replacing listener below
        // sliderContainer.addEventListener('touchend', stopDrag);
        sliderContainer.addEventListener("touchend", (event) => {
          if (this.isZoomed) stopDrag();

          const currentTime = new Date().getTime();

          if (currentTime - lastTouchTime <= DOUBLE_TAP_DELAY) {
            localStorage.removeItem('shopifyEventData');
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            this.dragDistance = 0;
            lastTouchTime = 0;
            zoomImage();
          } else {
            lastTouchTime = currentTime;
          }
        });

        // Pagination events
        prevButton.addEventListener("click", handlePrevClick);
        nextButton.addEventListener("click", handleNextClick);

        updateSlider(currentIndex);
      }
    }
  );
}
